import PolicyNoteDocument from './PolicyNoteDocument';

export default class PolicyNoteEmail {
	public id: number | null = null;
	public recordType: string | null = null;
	public dateSubmit: Date | null = null;
	public flagDate: Date | null = null;
	public adminOnly: boolean | null = null;
	public note: string | null = null;
	public correspondenceName: string | null = null;
	public correspondenceEmailAddress: string | null = null;
	public correspondencePhone1: string | null = null;
	public correspondencePhone2: string | null = null;
	public correspondenceRecvdOrSent: string | null = null;
	public correspondenceType: string | null = null;
	public correspondenceWho: string | null = null;
	public correspondenceSubject: string | null = null;
	public correspondenceReason: string | null = null;
	public complaintInitiated: boolean | null = null;
	public username: string | null = null;
	public docName: string | null = null;
	public dateUploaded: Date | null = null;
	public category: string | null = null;

	public constructor() {

	}
};